<template>
  <div class="softphone-widget" v-loading.fullscreen.sync="!isUserReady" :element-loading-text="$t('common.loading-please-wait')">
    <div class="softphone-widget__header">
      <div>
        <img src="/images/hiperme_isologotipo.png" width="35"/>
      </div>
      <div class="softphone-widget__header-user-container">
        <el-dropdown>
          <!-- <div class="softphone-widget__header-agent-container">
            <i class="fas fa-coffee"></i><span>descanso</span>
          </div> -->
          <span class="softphone-widget__dropdown-link">
            <user-item :user="user" :showFullname="false" :size="35" class="user-item"/>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="softphone-widget__dropdown-item" @click.native="updateStatus('connected')"><span class="status connected"></span>{{ $t('user-status.connected') }}</el-dropdown-item>
            <el-dropdown-item class="softphone-widget__dropdown-item" @click.native="updateStatus('away')"><span class="status away"></span>{{ $t('user-status.away') }}</el-dropdown-item>
            <el-dropdown-item class="softphone-widget__dropdown-item" @click.native="updateStatus('busy')"><span class="status busy"></span>{{ $t('user-status.busy') }}</el-dropdown-item>
            <el-dropdown-item class="softphone-widget__dropdown-item" @click.native="logout">{{ $t('user-buttons.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="softphone-widget__body">
      <i v-if="agent && active==='softphone' && (softphoneState === 'keypad'|| !softphoneState)" @click="active='console'" class="fas fa-arrow-left"></i>
      <the-soft-phone v-if="readyToStart" ref="softphone" v-show="active==='softphone'" :extension="extension" @change-state="changeSoftphoneState" @registered="registered" @init-janus="initJanus" @call="call">
        <template v-slot:transfer-template>
          <the-agent-transfer v-if="agent"></the-agent-transfer>
        </template>
      </the-soft-phone>
      <agent-console v-if="agent" :agent="agent" v-show="active==='console'" @make-call="active='softphone'"></agent-console>
    </div>
    <audio id="agent-notifications">
      <source
        src="/sounds/appointed.mp3"
        type="audio/ogg"
      />
    </audio>
    <audio id="agent-pending-chat">
			<source
				src="/sounds/done-for-you-612.mp3"
				type="audio/ogg"
			/>
		</audio>
  </div>
</template>
<script>
import mediaserver from '@/api/mediaserver';

import TheSoftPhone from '@/components/softphone-widget/TheSoftPhone.vue';
import TheAgentTransfer from '@/components/softphone-widget/TheAgentTransfer.vue';
import UserItem from '@/components/common/UserItem';
import { mapActions, mapGetters } from 'vuex';
import AgentConsole from '@/views/softphone-widget/AgentConsole.vue';

export default {
  data() {
    return {
      softphone: null,
      softphoneState: null,
      active: 'console',
      signOutAudio: new Audio('/sounds/sign-out.mp3'),

    };
  },
  components: {
    TheSoftPhone,
    TheAgentTransfer,
    UserItem,
    AgentConsole
  },
  mounted() {
    this.$emit('softphone-mounted', 'asdasda');
  },
  beforeDestroy() {
    this.$emit('softphone-unmounted', 'asdasdas');
  },
  methods: {
    ...mapActions([
      'fetchUserData',
      'listenToUser',
      'updateData',
      'updateStatus',
      'getShowAcceptChatWindow',
      'addCallHistory',
      'doCall'
    ]),
    handleSoftPhoneEvent(event) {
      this.$emit('softphone-event', event);
    },
    async start() {
        await this.fetchUserData();
        this.listenToUser(this.user.uid);
        this.updateData();
    },
    logout(){
      // this.$store.dispatch('signOut');
      this.$router.push({path: '/logout', query: {mode:'widget'}})
    },
    changeSoftphoneState(state) {
      console.log(state)
      this.softphoneState = state;
      if(['incall', 'calling', 'incoming', 'transfer'].includes(state)){
        this.active = 'softphone';
      }
    },
    registered(){
      if(!this.agent) return 
      console.log("aaaaa")
      this.$store.dispatch("doCallLogin")
      if (this.getLoggedInCallCenter) {
        this.$store.dispatch("SET_DO_UNREGISTER_REGISTER");
      }

    },
    async initJanus(){
      if(!this.agent) return
      await mediaserver.destroyAgentSession();
    },
    handleJanusOnAgentLogout(){
      console.log(this.$refs.softphone.janus)
      if (this.agent.call && this.$refs.softphone.janus) {
        this.$refs.softphone.janus.destroy()
      }
    },
    call(callTo){
      console.log('call to', this.agent)
      if(this.agent){
        console.log('dentro de call')

        this.doCall({number: callTo})
        .then(()=>this.addCallHistory({ from : 'call_center', call : {
        title: callTo,
        number: callTo,
        type: 'phone',
        date: new Date().getTime(),
      } }))
      }
      
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      getAgent: 'getAgent',
      getLoggedInCallCenter: 'getLoggedInCallCenter'
    }),
    isUserReady() {
      return this.user && this.user.extension !== '';
    },
    isAgentReady(){
      return this.agent && this.getLoggedStatus
    },
    agent(){
      if(typeof this.getAgent === 'object' && this.getAgent.number){
        return this.getAgent;
      }
      return null;
    },
    readyToStart(){
      if(this.agent){
        return this.agent.call && this.getLoggedStatus
      }
      return this.user && this.user.extension && this.user.extension !== ''
    },
    showSoftphone(){
      return true
    },
    getLoggedStatus(){
      console.log(this.$store.getters['getLogged'])
      return this.$store.getters['getLogged']
    },
    extension(){
      if(!this.agent){
        const stunServer = this.user.localExtension.stunServer ?? null;
        return {...this.user.localExtension, displayname : this.user.localExtension.name, number : this.user.localExtension.extension, stunServer: stunServer }
      }
      const stunServer = this.agent.extension.stunServer ?? null;
      return {...this.agent.extension, displayname: this.agent.number.toString(), number: this.agent.extension.extension, stunServer: stunServer}
    },
    showAcceptChat () {
      return this.getShowAcceptChatWindow;
    },
  },
  watch:{
    getLoggedStatus (value) {
      if(this.agent)
      if (!value) {
        this.signOutAudio.play()
        if (this.agent.call) {
          this.handleJanusOnAgentLogout()
          return
        }
      }

      if (value && this.agent.call) {
        this.$refs.softphone?.initJanus()
      }
      
    }
  },  
  async created(){
    if(!this.isUserReady){
      await this.start();
    }
    console.log('agent', this.agent);

    if(this.agent){
      this.active = 'console';
      this.$store.dispatch('startListenQueuesDashboard', this.agent.organization_id);
      this.$store.dispatch('listenAgentsDashboard', this.agent.organization_id);
      this.$store.dispatch('fetchBreaks');
      this.$store.dispatch('listenAgent');

    }else{
      this.active = 'softphone';
    }
  }


}
</script>
<style scoped>
.softphone-widget{
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  min-width: 300px;
}
.softphone-widget .softphone-widget__header .fa-user{
  font-size: 20px;
  margin-right: 5px;
}
.softphone-widget .softphone-widget__header .softphone-widget__dropdown-link{
  text-align: center;
  cursor: pointer;
}
.softphone-widget .softphone-widget__header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: .8em;
  padding: 5px 10px;
  background: var(--hiperpbx-grey);
}
.softphone-widget__header-user-container {
  display: flex;
  align-items: center;
  gap: 5px;
}

.softphone-widget__header-agent-container .fa-coffee{
  font-size: 25px;
  color: var(--hiperpbx-grey-dark);

}
.softphone-widget__dropdown-item{
  display: flex;
  align-items: center;
  gap: 5px;
}
.status{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: block;
}
.softphone-widget__header-user-container .status.connected{
  background: var(--hiperpbx-green);
}
.softphone-widget__header-user-container .status.away{
  background: var(--hiperpbx-yellow);
}
.softphone-widget__header-user-container .status.busy{
  background: var(--hiperpbx-red);
}

.fa-arrow-left{
  color: var(--hiperpbx-green);
  font-size: 20px;
  cursor: pointer;
}

.softphone-widget__body{
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: calc(100vh - 60px);
  padding: 10px;
}
</style>